module.exports = __webpack_public_path__ + "build/assets/Aleo-Italic-224ee00da5a615e5626d52101a8f9d88.woff";